import { PropsWithChildren } from 'react';
import classNames from 'classnames';

import styles from './CompensationViewField.module.scss';

interface Props {
  readonly className?: string;
}

export const CompensationViewRow = ({ children, className }: PropsWithChildren<Props>) => {
  return <div className={classNames(className, styles.compensationViewRow)}>{children}</div>;
};

export const CompensationViewField = ({ children }: PropsWithChildren) => {
  return <div className={styles.compensationViewFieldContainer}>{children}</div>;
};
